organizationService.$inject = [];

export default function organizationService() {
  class OrganizationService {
    constructor() {
      this._currentOrganizationId = null;
      this._currentOrganizations = [];
      this._currentOrganization = null;
    }

    setCurrentOrganizationId(id) {
      if (!id) throw new Error('id');

      this._currentOrganizationId = id;
    }

    getCurrentOrganizationId() {
      return this._currentOrganizationId;
    }

    clearCurrentOrganizationId() {
      this._currentOrganizationId = null;
    }

    setCurrentOrganizations(organizations) {
      if (!organizations) throw new Error('organizationService - setCurrentOrganizations() - organizations is required');

      this._currentOrganizations = organizations;
    }

    setCurrentOrganization(organization) {
      if (!organization) throw new Error('organizationService - setCurrentOrganization() - organization is required');

      this._currentOrganization = organization;
    }

    /**
     * @desc Gets the inmemory version of the current organizations
     * @return {Object}
     */
    getCurrentOrganizations() {
      return this._currentOrganizations;
    }

    /**
     * @desc Gets the inmemory version of the current organizations
     * @return {Object}
     */
    getCurrentOrganization() {
      return this._currentOrganization;
    }

    /**
     * @desc Gets whether the organization is enabled
     * @return {Object}
     */
    isCurrentOrganizationEnabled() {
      if (this._currentOrganization) {
        return this._currentOrganization.enabled;
      }
      return false;
    }

    isCurrentOrganizationAPromoter() { //eslint-disable-line
      if (!this._currentOrganization) throw new Error('organization is required');

      return this._currentOrganization.type === 'LIMITED_EXTERNAL';
    }
  }

  return new OrganizationService();
}



// WEBPACK FOOTER //
// ./src/services/organizationService.js